/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BecomeSpeakerQuery = {
    readonly _children: {
        readonly items: ReadonlyArray<{
            readonly title?: string;
            readonly metaTitle?: string | null;
            readonly formType?: string;
            readonly content?: string | null;
            readonly nameLabel?: string | null;
            readonly surnameLabel?: string | null;
            readonly emailLabel?: string | null;
            readonly companyNameLabel?: string | null;
            readonly registrationCityLabel?: string | null;
            readonly privacyPolicyLabelText?: string | null;
            readonly speakerTitleLabel?: string | null;
            readonly speakerBioLabel?: string | null;
            readonly speakerSocialMediaLabel?: string | null;
            readonly speakerPhotoLabel?: string | null;
            readonly speakerTalkTitle?: string | null;
            readonly speakerTalkNameLabel?: string | null;
            readonly speakerFormatLabel?: string | null;
            readonly speakerFormatTooltip?: string | null;
            readonly speakerLanguageLabel?: string | null;
            readonly speakerTrackLabel?: string | null;
            readonly speakerTrackTooltip?: string | null;
            readonly speakerAudienceLevelLabel?: string | null;
            readonly speakerTalkKeyPointsLabel?: string | null;
            readonly speakerTalkDescriptionLabel?: string | null;
            readonly speakerCoSpeakerLabel?: string | null;
            readonly speakerCodeOfConductAndSpeakerContractAgreementLabel?: string | null;
            readonly speakerAddTalkButtonLabel?: string | null;
            readonly submitButtonLabel?: string | null;
            readonly cityPlaceholder?: string | null;
            readonly speakerBioPlaceholder?: string | null;
            readonly speakerFacebookLinkPlaceholder?: string | null;
            readonly speakerLinkedinLinkPlaceholder?: string | null;
            readonly speakerTwitterLinkPlaceholder?: string | null;
            readonly speakerPhotoPlaceholder?: string | null;
            readonly speakerPhotoBottomDescription?: string | null;
            readonly speakerFormatPlaceholder?: string | null;
            readonly speakerLanguagePlaceholder?: string | null;
            readonly speakerTrackPlaceholder?: string | null;
            readonly speakerAudienceLevelPlaceholder?: string | null;
            readonly speakerTalkKeyPointsPlaceholder?: string | null;
            readonly speakerTalkDescriptionPlaceholder?: string | null;
            readonly speakerFormatValues?: ReadonlyArray<string | null> | null;
            readonly speakerLanguageValues?: ReadonlyArray<string | null> | null;
            readonly speakerTrackValues?: ReadonlyArray<string | null> | null;
            readonly speakerAudienceLevelValues?: ReadonlyArray<string | null> | null;
            readonly speakerBioTooltip?: string | null;
            readonly speakerTalkNameTooltip?: string | null;
            readonly speakerTalkDescriptionTooltip?: string | null;
            readonly speakerLanguageTooltip?: string | null;
        } | null> | null;
    } | null;
    readonly " $refType": "BecomeSpeakerQuery";
};
export type BecomeSpeakerQuery$data = BecomeSpeakerQuery;
export type BecomeSpeakerQuery$key = {
    readonly " $data"?: BecomeSpeakerQuery$data;
    readonly " $fragmentRefs": FragmentRefs<"BecomeSpeakerQuery">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BecomeSpeakerQuery",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PublishedContentConnection",
      "kind": "LinkedField",
      "name": "_children",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "metaTitle",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "formType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "content",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "nameLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "surnameLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "emailLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "companyNameLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "registrationCityLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "privacyPolicyLabelText",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerTitleLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerBioLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerSocialMediaLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerPhotoLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerTalkTitle",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerTalkNameLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerFormatLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerFormatTooltip",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerLanguageLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerTrackLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerTrackTooltip",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerAudienceLevelLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerTalkKeyPointsLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerTalkDescriptionLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerCoSpeakerLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerCodeOfConductAndSpeakerContractAgreementLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerAddTalkButtonLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "submitButtonLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cityPlaceholder",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerBioPlaceholder",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerFacebookLinkPlaceholder",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerLinkedinLinkPlaceholder",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerTwitterLinkPlaceholder",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerPhotoPlaceholder",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerPhotoBottomDescription",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerFormatPlaceholder",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerLanguagePlaceholder",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerTrackPlaceholder",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerAudienceLevelPlaceholder",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerTalkKeyPointsPlaceholder",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerTalkDescriptionPlaceholder",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerFormatValues",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerLanguageValues",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerTrackValues",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerAudienceLevelValues",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerBioTooltip",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerTalkNameTooltip",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerTalkDescriptionTooltip",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "speakerLanguageTooltip",
                  "storageKey": null
                }
              ],
              "type": "FormPagePublishedContent",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HomePublishedContent",
  "abstractKey": null
};
(node as any).hash = 'eba65e0259e1f5d799e18a03e7b95eed';
export default node;
